import Response from "../../Data/Domain/Response";
import Document from "../Domain/Document";
import {
  getUserDocumentsService,
  getDocumentByIdService,
  getDocumentsByUserService,
} from "./Documents.service";

/**
 * Fetch list of documents for a user/owner.
 * Accepts params like { userId, page, limit, ... } and forwards them to the service.
 * Returns { resources: Document[], count: number }
 */
export async function getUserDocumentsRepository(params) {
  const data = await getUserDocumentsService(params);
  return new Response(data, Document).getMultiple();
}

export async function getDocumentByIdRepository(id) {
  const data = await getDocumentByIdService(id);
  return new Response(data, Document).getSingle();
}

export async function getDocumentsByUserRepository(params) {
  console.log("getDocumentsByUserRepository called with params:", params);
  const data = await getDocumentsByUserService(params);
  return new Response(data, Document).getMultiple();
}